/**
 * 轨迹下载弹窗时间预设
 */

/**
 * @param {string} preset
 * @param {Function} dayjsLib
 * @param {any} prevRange
 */
export function resolveTrackDownloadRangeByPreset(preset, dayjsLib, prevRange = null) {
  if (!dayjsLib) return prevRange;
  if (preset === 'today') {
    return [dayjsLib().startOf('day'), dayjsLib().endOf('day')];
  }
  if (preset === 'last7') {
    return [dayjsLib().subtract(6, 'day').startOf('day'), dayjsLib().endOf('day')];
  }
  if (preset === 'last30') {
    return [dayjsLib().subtract(29, 'day').startOf('day'), dayjsLib().endOf('day')];
  }
  return prevRange;
}

export function listExportableTrackMemberNames(realTimeTrackData = {}) {
  return Object.keys(realTimeTrackData || {}).filter(
    (memberName) => realTimeTrackData[memberName] && realTimeTrackData[memberName].length > 0
  );
}
